import React from "react";
import { useTheme } from "../../../../Utils/useTheme";

export const VirtualBodyAdapter = ({ children }: any) => {
  const { border } = useTheme();

  return (
    <div
      style={{
        flex: 1,
        minHeight: 0,
        overflow: "auto",
        background: "rgba(255,255,255,0.86)",
        scrollbarGutter: "stable",
      }}
    >
      <div style={{ minWidth: "max-content", borderBottom: `1px solid ${border}` }}>
        {children}
      </div>
    </div>
  );
};
